import "./index.css";
import "./i18n";
import { Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import SuspenseFallback from "./components/loaders/SuspenseFallback";
import App from "./core/App";
import reportWebVitals from "./reportWebVitals";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
		},
	},
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
	<QueryClientProvider client={queryClient}>
		<Suspense fallback={<SuspenseFallback />}>
			<App />
		</Suspense>
	</QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
